export default {
  created() {
    if (typeof this.getSubviewEventStrategy !== 'function') {
      throw Error(
        'Components that use the flowController mixin must implement getSubviewEventStrategy'
      )
    }
  },
  methods: {
    __handleSubviewEvent(event) {
      // Get the strategy from the implementing component
      const strategy = this.getSubviewEventStrategy()

      // Look for a handle for the event type and call it with the payload
      strategy[event.type] && strategy[event.type](event)

      this.$emit('subview-event', event)
    }
  }
}
